import { setFlujo } from 'utils/fujo'

const allowedFlows = ['autogestion', 'agencia', 'fvt']
const useFirstLogin = (flujo: string) => {
  if (!allowedFlows.includes(flujo)) {
    window.location.replace('/autogestion/login/')
  }
  // Guardar Flujo de ingreso
  setFlujo(flujo)
}

export default useFirstLogin
